import { render, staticRenderFns } from "./history-wiki-graph.vue?vue&type=template&id=635de093&"
import script from "./history-wiki-graph.vue?vue&type=script&lang=ts&"
export * from "./history-wiki-graph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports